import React from 'react';
import hoc from './FieldHOC';
import _ from 'underscore';
import clone from 'clone';

class Checkboxes extends React.Component {
  constructor(props) {
    super(...arguments);
    this.state = {
      value: Checkboxes.getDerivedStateFromProps(props)
    };
  }

  static getDerivedStateFromProps(props){
    let checked = [];
    let selectedValue = 0;
    props.field.get('options').each((option, i) => {
      if (((option.get('selected') === 1 || option.get('selected') === "1") && typeof props.value === 'undefined') || (props.value && _.indexOf(props.value, option.get('id')) >= 0)) {
        checked.push(option.get('id'));
        selectedValue += option.getCurrencyValue();
      }
    });
    props.field.setSelectedValue(selectedValue);
    return {
      value: checked
    }
  }

  onChange(o, e) {
    let checked = clone(this.state.value);
    if (e.target.checked) {
      checked.push(o.get('id'));
    } else {
      checked = _.without(checked, o.get('id'));
    }

    let selected = [];
    let selectedValue = 0;
    this.props.field.get('options').each(option => {
      if (_.indexOf(checked, option.get('id')) >= 0) {
        selected.push(option);
        selectedValue += option.getCurrencyValue();
      }
    });

    this.props.field.setSelectedValue(selectedValue);
    this.setState({
      value: checked
    });
    this.props.onChange(checked);
  }

  render() {
    let field = this.props.field;
    let options = this.props.field.get('options');
    let boxes = options.map((option, i) => {
      const checked = _.indexOf(this.state.value, option.get('id')) >= 0;
      return <div className="checkbox" key={`option-${option.get('id')}`}>
        <label>
          <input
            aria-label={option.get('name')}
            type="checkbox"
            tabIndex={this.props.tabIndex}
            disabled={this.props.disabled}
            checked={checked}
            name={this.props.name + '[' + option.get('id') + ']'}
            onChange={this.onChange.bind(this, option)}
          />{' '}
          {option.get('name')}
        </label>
      </div>;
    });

    return (
      <div className="checkboxes">
        <label htmlFor={this.props.name}>{this.props.title || field.get('title')}</label>
        {this.props.errorComponent}
        <div>{boxes}</div>
      </div>
    );
  }
}

export default hoc(Checkboxes);
